import React from 'react';
import PropTypes from 'prop-types';
import QrCode from 'qrcode.react';
import api from 'api';
import Component from 'BaseComponent';
import { notice } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import convertToFormErrors from 'utils/convertToFormErrors';
import Field from 'form/Field';
import Form from 'form/Form';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';
import SubmitButton from 'form/SubmitButton';
import { withRouter } from 'react-router-dom';

@withRouter

@reduxForm({
  form: 'Enable2FA',
  validate: generateFormValidation({
    otp_code: [validators.required(), validators.minLength(6)],
  }),
  onSubmit(values, dispatch, props) {
    return dispatch(api.activate2fa({
      data: {
        type: '2fa_activation',
        attributes: {
          otp_code: values,
        },
      },
    }))
    .then(() => {
      props.history.push('/account');
      dispatch(notice('Enable2FA.success'));
    })
    .catch((response) => {
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class Enable2FA extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
    accountEmail: PropTypes.string,
  }

  componentDidMount() {
    api.getAccountOtpSecret()
      .then((result) => {
        const otpSecretKey = result.body.data && result.body.data.id;
        this.setState({ otpSecretKey });
      });
  }

  renderLoading() {
    return <span>Loading..</span>;
  }

  render() {
    const { handleSubmit, submitting, error, dirty, accountEmail } = this.props;
    return (
      <div>
        { this.state && this.state.otpSecretKey &&
        <div className="otp">
          <div className="otp__content">
            <p>
              Use the QR code below to configure your two-factor
              authenticator app.
            </p>
            <ol>
              <li>
                Download the free <strong>Google Authenticator</strong> app
                on your mobile device (available on both{' '}
                <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">
                  Android
                </a>{' '}
                and{' '}
                <a href="https://itunes.apple.com/app/google-authenticator/id388497605?mt=8">
                  iOS
                </a>{' '}
                stores);
              </li>
              <li>Tap on &quot;Add account&quot;</li>
            </ol>
          </div>
          <div className="otp__code">
            <QrCode value={`otpauth://totp/HardyPress (${accountEmail})?secret=${this.state.otpSecretKey}`} />
          </div>
          <div className="otp__key">{ this.state.otpSecretKey }</div>

          <Form error={error} onSubmit={handleSubmit}>
            <Field label="Enable2FA.otp" name="otp_code">
              <input type="text" className="form__input--large" />
            </Field>
            <SubmitButton
              dirty={dirty}
              className="button button--primary button--expand button--huge"
              submitting={submitting}
              label="EditAccount.submit"
            />
          </Form>
        </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Enable2FA.jsx